import { F360UnitDate } from "@/core/plugins/date/F360Date";
import useDate from "@/core/plugins/useDate";
import { computed, ref } from "vue";

export default function useVoucherTimer() {
  const date = useDate();
  const adicionarDoisDigitos = (date: number) =>
    date.toString().padStart(2, "0");

  const startTime = ref<Date>(date.now());
  const timer = ref<Date>(date.now());

  const horaFutura = computed(() =>
    date.add(startTime.value, 1, F360UnitDate.Hour)
  );
  const diffInSeconds = computed(() =>
    date.getDiff(horaFutura.value, timer.value, F360UnitDate.Second)
  );

  //watch(() => startTime.value, () => timer.value = startTime.value)

  const expireLimit = computed(() => {
    const minutosRestantes = Math.floor(diffInSeconds.value / 60);
    const segundosRestantes = diffInSeconds.value % 60;

    return `${adicionarDoisDigitos(minutosRestantes)}:${adicionarDoisDigitos(
      segundosRestantes
    )}`;
  });

  return {
    startTime,
    horaFutura,
    diffInSeconds,
    expireLimit,
    timer,
    date
  };
}
